import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { GearsAnimationStatus } from './gearsanimation';

@Injectable()
export class LoadingStatus {

  private loading$: BehaviorSubject<boolean>;

  constructor() {
    this.loading$ = new BehaviorSubject(false);
  }

  setLoadingStatus(loading: boolean) {
    this.loading$.next(loading);
  }

  getLoadingStatus(): Observable<boolean> {
    return this.loading$.asObservable();
  }
}

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private status: LoadingStatus, private gearsAnimationStatus: GearsAnimationStatus) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.status.setLoadingStatus(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    Promise.resolve().then(() => this.status.setLoadingStatus(true));

    return new Observable(observer => {
      const subscription = next.handle(req)
        .subscribe(
          event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {
            this.removeRequest(req);
            observer.error(err);
            this.gearsAnimationStatus.setGearsAnimation(false);
          },
          () => {
            this.removeRequest(req);
            observer.complete();
          });
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}

